var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    width: 48,
    height: 48,
    rx: 5,
    transform: "rotate(90 54 0)",
    fill: "#0CBFE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 15.6659H18C17.4477 15.6659 17 16.1136 17 16.6659V31.3326C17 31.8848 17.4477 32.3326 18 32.3326H42C42.5523 32.3326 43 31.8848 43 31.3326V16.6659C43 16.1136 42.5523 15.6659 42 15.6659ZM18 14.6659C16.8954 14.6659 16 15.5613 16 16.6659V31.3326C16 32.4371 16.8954 33.3326 18 33.3326H42C43.1046 33.3326 44 32.4371 44 31.3326V16.6659C44 15.5613 43.1046 14.6659 42 14.6659H18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7825 15.5124C16.9593 15.3002 17.2746 15.2716 17.4867 15.4484C19.2308 16.9017 21.9626 19.0813 24.4875 20.8951C25.7509 21.8027 26.9539 22.6126 27.9511 23.1934C28.4502 23.4841 28.8886 23.712 29.2513 23.8658C29.6286 24.0257 29.872 24.0825 30 24.0825C30.1374 24.0825 30.384 24.0289 30.755 23.885C31.1135 23.7459 31.5454 23.5397 32.0367 23.276C33.0185 22.7491 34.203 22.0116 35.4537 21.177C37.9535 19.5088 40.6843 17.4753 42.5235 16.0234C42.7402 15.8522 43.0546 15.8892 43.2258 16.106C43.3969 16.3227 43.3599 16.6371 43.1431 16.8082C41.2879 18.2729 38.5353 20.3228 36.0088 22.0088C34.7463 22.8512 33.5318 23.6085 32.5096 24.1571C31.9989 24.4312 31.5275 24.6579 31.1167 24.8173C30.7182 24.9719 30.3293 25.0825 30 25.0825C29.6613 25.0825 29.263 24.9569 28.861 24.7864C28.4445 24.6099 27.9659 24.3593 27.4478 24.0575C26.4106 23.4534 25.1782 22.6226 23.9041 21.7073C21.354 19.8753 18.6025 17.6799 16.8466 16.2166C16.6344 16.0398 16.6058 15.7245 16.7825 15.5124ZM23.8922 23.606C24.1094 23.7766 24.1471 24.0909 23.9765 24.308L17.5598 32.4747C17.3892 32.6918 17.0749 32.7296 16.8577 32.559C16.6406 32.3884 16.6029 32.074 16.7735 31.8569L23.1902 23.6902C23.3608 23.4731 23.6751 23.4354 23.8922 23.606ZM36.1077 23.606C36.3249 23.4354 36.6392 23.4731 36.8098 23.6902L43.2265 31.8569C43.3971 32.074 43.3594 32.3884 43.1422 32.559C42.9251 32.7296 42.6108 32.6918 42.4402 32.4747L36.0235 24.308C35.8529 24.0909 35.8906 23.7766 36.1077 23.606Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 24C60 27.3137 57.3137 30 54 30C50.6863 30 48 27.3137 48 24C48 20.6863 50.6863 18 54 18C57.3137 18 60 20.6863 60 24Z",
    fill: "#9088DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 29C56.7614 29 59 26.7614 59 24C59 21.2386 56.7614 19 54 19C51.2386 19 49 21.2386 49 24C49 26.7614 51.2386 29 54 29ZM54 30C57.3137 30 60 27.3137 60 24C60 20.6863 57.3137 18 54 18C50.6863 18 48 20.6863 48 24C48 27.3137 50.6863 30 54 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 27.3137 9.31371 30 6 30C2.68629 30 0 27.3137 0 24C0 20.6863 2.68629 18 6 18C9.31371 18 12 20.6863 12 24Z",
    fill: "#9088DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 29C8.76142 29 11 26.7614 11 24C11 21.2386 8.76142 19 6 19C3.23858 19 1 21.2386 1 24C1 26.7614 3.23858 29 6 29ZM6 30C9.31371 30 12 27.3137 12 24C12 20.6863 9.31371 18 6 18C2.68629 18 0 20.6863 0 24C0 27.3137 2.68629 30 6 30Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 9.99963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPreview);
export default __webpack_public_path__ + "static/media/EmailPreview.9b63b6b5d2812b9c1dcf0bbfc12d062a.svg";
export { ForwardRef as ReactComponent };